module.exports = __webpack_public_path__ + "static/img/yiliao.7c6b81c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/yiliao.jpg
// module id = s8jS
// module chunks = 1